import { render, staticRenderFns } from "./report_space.vue?vue&type=template&id=1f1165b2"
import script from "./report_space.vue?vue&type=script&lang=js"
export * from "./report_space.vue?vue&type=script&lang=js"
import style0 from "./report_space.vue?vue&type=style&index=0&id=1f1165b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports